//import liraries
import React, { Component, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import {updateReimbursement} from '../../services/ReimbursementService';
import { Button, Dialog, DialogTitle } from '@mui/material';
import { useAuth } from '../../AuthProvider';

// create a component
const EditInvoiceCard = (props) => {
    const userContext = useAuth();
    const {open, onClose,record,reimbursements,reimbursementsApproved,setReimbursements,setReimbursementsApproved} = props;
    const [claimedAmount,setClaimedAmount] = React.useState('');
    useEffect(()=>{ 
        if(record){
        setClaimedAmount(record.claimedAmount);
        }
    },[open]);
    const saveRecord = () => {
        console.log(record);
        record.claimedAmount = claimedAmount;
        if(record.status === 'pending'){
            
            let index = reimbursements.findIndex((item) => item.reimbursementId === record.reimbursementId);
            reimbursements[index] = record;
            setReimbursements(reimbursements);
        }else if(record.status === 'approved'){
            let index = reimbursementsApproved.findIndex((item) => item.reimbursementId === record.reimbursementId);
            reimbursementsApproved[index] = record;
            setReimbursementsApproved(reimbursementsApproved);
        }
        
        updateReimbursement(record,userContext.token);
       
        onClose();
    }
    return (
        <Dialog onClose={onClose} open={open}>
        <DialogTitle>Confirm claimed amount</DialogTitle>
        <div >
           <TextField className="textField" id="amount-claimed" label="Claimed amount" onChange={(e)=>{setClaimedAmount(e.target.value)}} variant="outlined" value={claimedAmount} />
           <Button  className="buttonField" variant="contained" onClick={saveRecord}>Save</Button>
        </div>
        </Dialog>
    );
};


//make this component available to the app
export default EditInvoiceCard;
